export const FEED_LAYOUTS = {
  GRID: 'grid',
  SLIDER: 'slider',
  LIST: 'list',
  MASONRY: 'masonry',
  GRID_2X2: 'grid-2x2',
  GRID_3X3: 'grid-3x3',
  GRID_4X2: 'grid-4x2',
  SINGLE_FEATURED: 'single-featured',
};

export const LAYOUT_FAMILIES = [
  FEED_LAYOUTS.GRID,
  FEED_LAYOUTS.SLIDER,
  FEED_LAYOUTS.LIST,
  FEED_LAYOUTS.MASONRY,
];

export const POST_ORDERS = {
  RANDOM: 'random',
  NEWEST: 'newest',
  OLDEST: 'oldest',
};

export function isGridLayout(feedLayout) {
  return resolveLayoutFamily(feedLayout) === FEED_LAYOUTS.GRID;
}

export function resolveFeedLayout(feedLayout) {
  return feedLayout || FEED_LAYOUTS.GRID;
}

export function resolveLayoutFamily(feedLayout) {
  const layout = resolveFeedLayout(feedLayout);
  if (layout === FEED_LAYOUTS.SLIDER) {
    return FEED_LAYOUTS.SLIDER;
  }
  if (layout === FEED_LAYOUTS.MASONRY) {
    return FEED_LAYOUTS.MASONRY;
  }
  if (layout === FEED_LAYOUTS.LIST || layout === FEED_LAYOUTS.SINGLE_FEATURED) {
    return FEED_LAYOUTS.LIST;
  }
  return FEED_LAYOUTS.GRID;
}

export function applyFeedLayoutDefaults(feedLayout, config) {
  const family = resolveLayoutFamily(feedLayout);
  const next = Object.assign({}, config, { feedLayout: family });
  if (family === FEED_LAYOUTS.SLIDER) {
    next.sliderVisibleCount = parseInt(next.columns, 10) || next.sliderVisibleCount || 4;
  }
  return next;
}

export function orderFeedPosts(posts, postOrder, seed) {
  const list = (posts || []).slice();
  const order = postOrder || POST_ORDERS.NEWEST;

  if (order === POST_ORDERS.RANDOM) {
    return shuffleWithSeed(list, seed);
  }

  list.sort(function compareTimestamps(a, b) {
    return timestampValue(a) - timestampValue(b);
  });

  if (order === POST_ORDERS.OLDEST) {
    return list;
  }

  return list.reverse();
}

export function applyCustomPostOrder(posts, customPostOrder) {
  const list = (posts || []).slice();
  const order = customPostOrder || [];
  if (!order.length) {
    return list;
  }
  const byId = {};
  list.forEach((post) => {
    if (post && post.id) {
      byId[String(post.id)] = post;
    }
  });
  const result = [];
  const used = {};
  order.forEach((id) => {
    const key = String(id);
    if (byId[key]) {
      result.push(byId[key]);
      used[key] = true;
    }
  });
  list.forEach((post) => {
    if (post && post.id && !used[String(post.id)]) {
      result.push(post);
    }
  });
  return result;
}

export function excludeHiddenPosts(posts, hiddenPostIds) {
  const hidden = {};
  (hiddenPostIds || []).forEach((id) => {
    hidden[String(id)] = true;
  });
  if (!Object.keys(hidden).length) {
    return posts || [];
  }
  return (posts || []).filter((post) => post && post.id && !hidden[String(post.id)]);
}

export function applyManualPostLayout(posts, customPostOrder, hiddenPostIds) {
  return excludeHiddenPosts(applyCustomPostOrder(posts, customPostOrder), hiddenPostIds);
}

function timestampValue(post) {
  if (!post || !post.timestamp) {
    return 0;
  }
  const value = Date.parse(post.timestamp);
  return Number.isNaN(value) ? 0 : value;
}

function shuffleWithSeed(items, seed) {
  const arr = items.slice();
  let state = Math.abs(parseInt(seed, 10) || 1) % 2147483647;
  if (!state) {
    state = 1;
  }
  for (let i = arr.length - 1; i > 0; i -= 1) {
    state = (state * 16807) % 2147483647;
    const j = state % (i + 1);
    const current = arr[i];
    arr[i] = arr[j];
    arr[j] = current;
  }
  return arr;
}



// WEBPACK FOOTER //
// ./src/components/editor/apps/InstagramFeed/layoutPresets.js